import React from "react";
import { connect } from 'react-redux';
import styles from './Services.module.scss'
import showModalDefault from "../../../../../../helpers/ui/ModalDefault";
import { updateBodyBuilder } from "../../../../../../redux/actions/DeploymentActions";
import TemplateSelect from "./components/TemplateSelect";
import { APP_TYPES, reorderApps } from "../../../_helpers/custom";
import AddPlaceholder from "./components/service/components/serviceContent/components/AddPlaceholder";
import { generateRandomID, scrollToAnchor } from "../../../../../../helpers/common";
import Service from "./components/service/Service";

function Services({onProjectSave, apps, bodyBuilder, messages, dispatch}) {

    let selected = [];

    APP_TYPES.map(type => {
        selected = [...selected, ...bodyBuilder[type]]
    })

    return (
        <>
            {
                selected.map((app, index) => (
                    <Service
                        onProjectSave={onProjectSave}
                        app={app}
                        messages={messages}
                        key={`${index}_${app._id || app.name || app.code}`} // apps can be reordered, so unique index is required
                    />
                ))
            }
            <div className={styles.add}>
                <AddPlaceholder
                    margin='0 10px 0 0'
                    alwaysHidden
                    title={`Add docker service`}
                    target='add-button'
                    onClick={() => {

                        let newApps = [...bodyBuilder.web];
                        const _id = generateRandomID();

                        const isDefaultNetwork = bodyBuilder.networks.find(n => n.name === 'default_network');

                        const newApp = [{
                            ...{
                                name: '',
                                code: '',
                                domain: '',
                                shared_ports: [{host_port: '80', container_port: ''}],
                                versions: [],
                                custom: true,
                                type: 'web',
                                network: !!isDefaultNetwork ? [isDefaultNetwork.id] : [],
                                restart: 'always',
                                timestamp: new Date().toISOString(),
                                _id,
                            }
                        }]

                        newApps = [...newApps, ...newApp];
                        newApps = reorderApps(newApps);
                        dispatch(updateBodyBuilder({...bodyBuilder, ...{web: newApps}}));

                        setTimeout(() => {
                            scrollToAnchor(`web-app-${_id}`, null, true, 'builder-container');
                            const nameInput = document.getElementById(`custom-${_id}-name`)
                            if (nameInput?.focus) nameInput.focus();
                        }, 200)
                    }}
                />
                <AddPlaceholder
                    alwaysHidden
                    title={`Add from template`}
                    target='add-button'
                    onClick={() => {
                        showModalDefault({
                            component: <TemplateSelect apps={apps}/>,
                            title: `Add docker service`,
                            maxWidth: '700px',
                        })
                    }}
                />
            </div>
        </>
    )
}

const mapStateToProps = state => ({
    bodyBuilder: state.deployment.bodyBuilder,
    messages: state.deployment.messages,
})

export default connect(mapStateToProps)(Services)